import { getWidthMetrics } from './getWidthMetrics';
import type { Chart } from './types';
import { BY_METRIC_LINE_WIDTH, SplitSortBy } from './types';

export const resolveTooltipMetrics = (config: Chart): string[] => {
  if (!('leftAxisSeries' in config)) {
    return [];
  }

  const onAnAxis = new Set(
    [config.primaryMetric, config.secondaryMetric].filter(Boolean),
  );
  const sizedBy = [config.leftAxisSeries, config.rightAxisSeries].flatMap(
    (series) =>
      series?.lineWidth === BY_METRIC_LINE_WIDTH && series.lineWidthMetric
        ? [series.lineWidthMetric]
        : [],
  );

  return [...new Set(sizedBy)].sort().filter((metric) => !onAnAxis.has(metric));
};

export const getSortMetrics = (config: Chart): string[] => {
  if (!('splitSort' in config)) {
    return [];
  }

  const sort = config.splitSort;

  if (sort?.by !== SplitSortBy.value || !sort.metric) {
    return [];
  }

  const alreadyRequested = new Set(
    [
      config.primaryMetric,
      config.secondaryMetric,
      ...getWidthMetrics(config),
    ].filter(Boolean),
  );

  return alreadyRequested.has(sort.metric) ? [] : [sort.metric];
};
